import React, { ReactNode, ReactElement, useState, useEffect } from 'react'
import { Flex, Box, ThemeUIStyleObject } from 'theme-ui'
import { useAppDispatch, useAppSelector } from 'store/hooks'
import { navigate } from 'gatsby'
import { useEntryTracking } from 'utils/campaignTracking'
import { resetTrackingData } from 'store/tracking'
import { StaticPageHeader } from 'components/HomePage/Header'
import OrgMobileNavMenuTray from 'components/HomePage/Header/MobileNavMenuTray/MobileNavMenuTray'
import OrgStaticPageFooter from 'components/Organization/HomePage/OrgStaticFooter/OrgStaticFooter'
import { StaticPageWrapper } from 'components/NewStaticPage'
import { TrayPresenter } from 'ui'

export interface LinkInfo {
  text: string
  href?: string
  to?: string
}

export interface StaticPageProps {
  shouldShowLoginOrGoToControlPanelButton?: boolean
  shouldShowFooter?: boolean
  intraPageLinks?: LinkInfo[]
  children?: ReactNode
  hasMaxWidth?: boolean
  containerStyles?: ThemeUIStyleObject
  customTrayOrModalDialog?: ReactNode
}

export default function OrgStaticPage({
  children,
  containerStyles,
  shouldShowFooter = true,
  customTrayOrModalDialog,
}: StaticPageProps): ReactElement {
  const dispatch = useAppDispatch()
  const [isMobileNavMenuOpen, setIsMobileNavMenuOpen] = useState(false)
  const trackingRedirectURL = useAppSelector(s => s.tracking.trackingRedirectURL)

  useEntryTracking()

  useEffect(() => {
    trackingRedirectURL && navigate(trackingRedirectURL)
    dispatch(resetTrackingData())
  }, [trackingRedirectURL, dispatch])

  return (
    <>
      <StaticPageWrapper
        aria-hidden={isMobileNavMenuOpen}
        className="ios-scrolling-glitches-fix"
        // changing the positioning is important for the correct voiceover work on iOS
        sx={{ position: isMobileNavMenuOpen ? 'static' : 'relative', ...containerStyles }}
      >
        <StaticPageHeader setIsMobileNavMenuOpen={setIsMobileNavMenuOpen} shouldUseMainHeader />
        <Flex
          sx={{
            flex: '1',
            width: '100%',
            flexDirection: 'column',
          }}
        >
          <Flex sx={{ flex: 1, justifyContent: 'center' }}>{children}</Flex>
        </Flex>
        {shouldShowFooter && (
          <Box
            sx={{
              width: '100%',
            }}
          >
            <OrgStaticPageFooter />
          </Box>
        )}
      </StaticPageWrapper>
      <OrgMobileNavMenuTray
        dismiss={() => setIsMobileNavMenuOpen(false)}
        isOpen={isMobileNavMenuOpen}
      />
      {customTrayOrModalDialog}
      <TrayPresenter />
    </>
  )
}
